import {
  Avatar,
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  Menu,
  MenuItem,
  Paper,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import CommonModel from "../../components/dialog/Common";
import { getSearchdata } from '../../utils/common';
import { INSTAGRAM_TYPE_WITH_CAPS, TOOLTIP_STYLES, YOUTUBE_TYPE_WITH_CAPS, getFixedValue, trunCateString } from "../../utils/constant";
import { getInfluencerListFordashboard } from './action';
import { updateDashboard } from './dashboardSlice';
import SearchBox from "./searchBox";
import SelectedInfluncers from "../../components/dialog/SelectedInfluncers";
import ConfirmationModal from "../../components/dialog/ConfirmationModal";
import deselectGif from '../../assets/images/icons/deselect.gif'
import { getWishlistById } from "../company-wishlist/action";
import CreateWishlistModal from "../../components/dialog/CreateWishlistModal";
import WishlistListingModal from "../../components/dialog/WishlistListingModal";
import CustomizedSnackbars from "../../components/snackbar";
import { useAddWishlistInfluencersMutation, useDeleteWishlistInfluencersMutation, useGetUserWishlistQuery } from "../../redux/api";
import plusWishlistIcon from '../../assets/images/icons/plusWishlistIcon.svg'
import plusIcon from '../../assets/images/icons/plusIcon.svg'
import { updateWishlist } from "../company-wishlist/wishlistSlice";
import deleteIcon from '../../assets/images/icons/deleteicon2.svg'
import bookmarkWhite from '../../assets/images/icons/bookmarkwhite.svg'
import { TableVirtuoso } from "react-virtuoso";
import WishlistSidebar from "./WishlistSidebar";
function getVirtuosoHeaderRow({ order, orderBy, handleRequestSort, filters,isScreenZoomed }) {
  const headCells = [
    { id: "profile", label: "Profiles", type: "", numeric: false, disablePadding: true, width: "120px" },
    { id: "wishlist", label: " ", type: "", numeric: false, disablePadding: true, width:isScreenZoomed ? '36px' : "31px" },
    {
      id: "followers",
      label: filters?.platform === INSTAGRAM_TYPE_WITH_CAPS ? "Followers" : "Subscribers",
      type: "",
      numeric: false,
      disablePadding: true, width: "40px"
    },
    {
      id: "avg_likes",
      label: "Avg Likes",
      type: "",
      numeric: false,
      disablePadding: true, width:isScreenZoomed ? "50px" : "40px"
    },
    {
      id: "avg_reel",
      label: filters?.platform === INSTAGRAM_TYPE_WITH_CAPS ? isScreenZoomed ?  "Reel views" : "Avg reel views" : "Avg views",
      type: "",
      numeric: false,
      disablePadding: true, width:isScreenZoomed ? "60px" :  "60px"
    },
    {
      id: "avg_comment",
      label: "Avg Comment",
      type: YOUTUBE_TYPE_WITH_CAPS,
      numeric: false,
      disablePadding: true, width: "40px"
    },
    {
      id: "ER",
      label: "ER",
      type: INSTAGRAM_TYPE_WITH_CAPS,
      numeric: false,
      disablePadding: true, width:isScreenZoomed ? "20px" : "30px"
    },
    { id: "category", label: "Category", type: "", numeric: false, disablePadding: true, width: "40px" },
    { id: "location", label: "Location", type: "", numeric: false, disablePadding: true, width:isScreenZoomed ? '50px' :  "80px" },
    { id: "categories", label: "Categories", type: "", numeric: false, disablePadding: true, width:isScreenZoomed? '100px' : "150px" },
  ];
  return (
    <TableRow>
      {headCells
        .filter((cell) => cell.type === "" || cell.type.toLowerCase() === filters?.platform?.toLowerCase())
        .map((cell) => (
          <TableCell
            width={cell.width || '100px'}
            component={"th"}
            key={cell.id}
            align={cell.numeric ? "right" : "left"}
            padding={cell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === cell.id ? order : false}
            sx={{ position: "sticky", top: 0, zIndex: 10, background: '#DBECFF !important', height: "50px", padding: '16px', border: '0px solid red' }}
          >
            <TableSortLabel
              active={orderBy === cell.id}
              direction={orderBy === cell.id ? order : "asc"}
              onClick={(e) => handleRequestSort(e, cell.id)}
              IconComponent={() => null}
            >
              {cell.label}
              {orderBy === cell.id && (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              )}
            </TableSortLabel>
          </TableCell>
        ))}
    </TableRow>
  );
}
const InfluencersListing = ()=> {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [addWishlistInfluencers] = useAddWishlistInfluencersMutation();
  const [deleteWishlistInfluencers] = useDeleteWishlistInfluencersMutation();
  const { data: wishlistGetRes, isSuccess } = useGetUserWishlistQuery();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [open, setOpen] = useState(false);
  const {isScreenZoomed} = useSelector(state=>state.commonSlice);
  const {
    totalCount,
    filters,
    list, page, selectedInfluencers, showLoading,limit
  } = useSelector((state) => state.dashboardSlice);
  const { wishlistList, selectedWishlist, showIconHighlitedForInfluncers } = useSelector(state => state.wishlistSlice)
  const currentPage = useRef(parseInt(page || '0'));
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [deselectConfirmationModal, setDeselectConfirmationModal] = useState(false);
  const [createWishlistModalOpen, setCreateWishlistModalOpen] = useState(false);
  const [showWishlistListingModal, setShowWishlistListingModal] = useState(false);
  const [influencerIdOnFirstWishlistSelect, setInfluencerIdOnFirstWishlistSelect] = useState(null)
  const [snackbar, setSnackbar] = useState({
    message: "",
    severity: "success",
    open: false,
  });
  const [menuPosition, setMenuPosition] = useState(null)
  const handleStateWishlistDropdown = useCallback((event, id,) => {
    event.preventDefault();
    event.stopPropagation();
    setInfluencerIdOnFirstWishlistSelect(id);
    const rect = event.currentTarget.getBoundingClientRect?.();
    if (rect) {
      const iconWidth = rect.width;
      const horizontalOffset = iconWidth
      setMenuPosition({
        top: rect.bottom + window.scrollY + 4,
        left: rect.left + window.scrollX + horizontalOffset,
      });
    } else {
    }
  }, [])
  
useEffect(() => {
  currentPage.current = parseInt(page || '0');
}, [page]);

  const iconRef = useRef();
  const wishlistId = searchParams.get('wishlistId')
  const handleDeleteInfluncersFromSelectedList = useCallback(
    (id) => {
      const updatedInfluncersList = selectedInfluencers.filter((item) => item.id !== id)
      dispatch(updateDashboard({ selectedInfluencers: updatedInfluncersList }))
    },
    [dispatch, selectedInfluencers])
  useEffect(() => {
    if (wishlistGetRes?.status === "SUCCESS") {
      dispatch(updateWishlist({ wishlistList: wishlistGetRes?.result?.data, totalCount: wishlistGetRes?.result.count }))
    }
  }, [isSuccess, wishlistGetRes, dispatch]);
  const handleAddInfluncerToList = useCallback(async (id = null, Wid = null) => {
    const selectedIds = selectedInfluencers.map((i) => i.id);
    try {
      const res = await addWishlistInfluencers({ influncersList: Boolean(id) ? [id] : selectedIds, wishlistId: Wid ? Wid : selectedWishlist?.id }).unwrap();
      setInfluencerIdOnFirstWishlistSelect(null)
      if (res?.status === "SUCCESS") {
        setSnackbar({
          message: res.message,
          severity: "success",
          open: true,
        });
        if (Boolean(id)) {
          dispatch(updateWishlist({ showIconHighlitedForInfluncers: [...showIconHighlitedForInfluncers, id] }))
        }
        else {
          dispatch(updateWishlist({ showIconHighlitedForInfluncers: [...showIconHighlitedForInfluncers, ...selectedIds] }))
        }
        dispatch(updateDashboard({ selectedInfluencers: [] }))
      } else {
        setSnackbar({
          message: res.message,
          severity: "error",
          open: true,
        });
      }
    } catch (error) {
      setSnackbar({
        message: "Something went wrong",
        severity: "error",
        open: true,
      });
    }
    setMenuPosition(null);
  }, [addWishlistInfluencers, dispatch, selectedInfluencers, selectedWishlist?.id, showIconHighlitedForInfluncers])
  const getWishlistByWishlistId = useCallback(async () => {
    const id = wishlistId;
    if (!id) {
      dispatch(updateWishlist({ selectedWishlist: {} }))
      return;
    }
    try {
      const res = await getWishlistById(id);
      dispatch(updateWishlist({ selectedWishlist: res }));
      if (influencerIdOnFirstWishlistSelect) {
        handleAddInfluncerToList(influencerIdOnFirstWishlistSelect, res?.id)
      }
      if (res.length === 0) {
        setSnackbar({
          message: "No Record found for Wishlist",
          severity: "error",
          open: true,
        });
      }
    } catch (error) {
      setSnackbar({
        message: "No Record found for Wishlist",
        severity: "error",
        open: true,
      });
    }
  }, [dispatch, handleAddInfluncerToList, influencerIdOnFirstWishlistSelect, wishlistId])
  useEffect(() => {
    getWishlistByWishlistId();
  }, [wishlistId, getWishlistByWishlistId])
  const handleRequestSort = useCallback(
    (event, property) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
      dispatch(
        updateDashboard({
          sort_type: isAsc ? "asc" : "desc",
          sort_key: property,
        }),
      );
    },
    [order, orderBy, dispatch],
  )
  useEffect(() => {
    dispatch(
      updateDashboard({
        filters: getSearchdata(),
        selectedInfluencers: [],
      }),
    );
    dispatch(updateWishlist({ showIconHighlitedForInfluncers: [] }))
  }, [dispatch])
  const loadMore = useCallback(() => {
    if (loading || !hasMore) return;
    setLoading(true);
    const nextPage = currentPage.current + 1;
    currentPage.current = nextPage;
    dispatch(updateDashboard({ showLoading: true, limit: limit || 20, page: nextPage }));
    dispatch(getInfluencerListFordashboard());
    setLoading(false);
  }, [dispatch, loading, hasMore]);
  useEffect(() => {
    if (list.length >= totalCount) {
      setHasMore(false);
    } else {
      setHasMore(true);
    }
  }, [list.length, totalCount]);
  const handleDeleteInfluncersFromWishlist = useCallback(async (id) => {
    try {
      const res = await deleteWishlistInfluencers({ wishlistId: selectedWishlist?.id, influncersList: [id] }).unwrap();
      if (res.status === "SUCCESS") {
        setSnackbar({
          message: res.message,
          severity: "success",
          open: true,
        });
        dispatch(updateWishlist({ showIconHighlitedForInfluncers: showIconHighlitedForInfluncers.filter((item) => item !== id) }))
        setTimeout(() => { }, 1500);
      } else {
        setSnackbar({
          message: res.message,
          severity: "error",
          open: true,
        });
      }
    } catch (error) {
      setSnackbar({
        message: "Something went wrong",
        severity: "error",
        open: true,
      });
    }
  }, [deleteWishlistInfluencers, dispatch, selectedWishlist?.id, showIconHighlitedForInfluncers])
  const handleDeselectAllInfluncer = () => {
    dispatch(updateDashboard({ selectedInfluencers: [] }))
    setDeselectConfirmationModal(false);
  }
  const checkIfIdIsAvailableInSelectedInfluncers = useCallback(
    (id) => {
      return showIconHighlitedForInfluncers.includes(id)
    },
    [showIconHighlitedForInfluncers],
  )
  const footer = useCallback(
    () => {
      return (
        <>{showLoading && <TableRow>
          <TableCell colSpan={9} align="center">
            <CircularProgress sx={{
              color: 'rgba(200, 80, 192, 1)',
            }} size={40} />
          </TableCell>
        </TableRow>}</>
      )
    },
    [showLoading],
  )
  const MemoizedTable = useCallback((props) => (
    <Table stickyHeader {...props} sx={{ tableLayout: 'fixed', width: '100%' }} />
  ), []);
  const MemoizedTableRow = useCallback((props) => (
    <TableRow
      sx={{
        "&:hover": {
          backgroundColor: '#F0F7FF !important',
          "& td": { backgroundColor: "inherit !important" },
        },
        height: '60px',
      }}
      {...props}
      hover
    />
  ), []);
  const headerContent = useMemo(() =>
    getVirtuosoHeaderRow({ order, orderBy, handleRequestSort, filters,isScreenZoomed }),
    [order, orderBy, filters, handleRequestSort,isScreenZoomed]
  );
  const footerContent = useMemo(() => footer(), [footer]);
  const renderItemContent = useCallback((index, row) => {
    const showWishlistIconHighlighted = checkIfIdIsAvailableInSelectedInfluncers(row.id);
    let categories = JSON.parse(row?.profileNiche || "[]")?.length > 0 ? JSON.parse(row?.profileNiche)?.map((v) => ({ title: v?.option, id: v.id })) : [];
    return (
      <>
        <TableCell component="td" scope="row" >
          <Stack direction={"row"} spacing={2}>
            <div class="MuiAvatar-root MuiAvatar-circular css-1nn861f-MuiAvatar-root" style={{ display: 'flex', border: '0px solid red', width: 'fit-content', gap: '5px', justifyContent: 'center', alignItems: 'center' }}>
              <Checkbox
                checked={selectedInfluencers.map((i) => i.id)?.includes(row.id)}
                onChange={(e) => {
                  if (e.target.checked) {
                    dispatch(updateDashboard({ selectedInfluencers: [...selectedInfluencers, row] }))
                  } else {
                    handleDeleteInfluncersFromSelectedList(row.id)
                  }
                }}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              <img alt="" style={{ height: '35px', width: '35px', borderRadius: "100px" }} src={row.picture ? row.picture : "/profile.jpg"} className="MuiAvatar-img" />
            </div>
            <a href={`/userManagement/details/${row.id}`} target="_blank" rel="noreferrer" className="text-decoration-none" style={{ fontSize: '13px', paddingTop: 7, fontWeight: '500', letterSpacing: '0px' ,textTransform:'capitalize'}} ><Tooltip componentsProps={TOOLTIP_STYLES}
              title={row?.name}
              arrow={true}>{trunCateString((row?.name || "Unknown"), 15)}</Tooltip></a>
          </Stack>
        </TableCell>
        <TableCell
          component="td"
          scope="row"
          sx={{
            padding: '4px',
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <Box sx={{ position: 'relative', height: '30px', width: '100%', border: '0px solid red', }}>
            <Box
              key={row.id}
              sx={{
                border: '0px solid blue',
                display: 'flex',
                flexDirection: 'row',
                height: '30px',
                width: showWishlistIconHighlighted ? '100%' : '30px', borderRadius: '4px',
                background:
                  'linear-gradient(119deg,rgba(200, 80, 192, 0.3) 42%, rgba(65, 88, 208, 0.3) 100%)',
                padding: showWishlistIconHighlighted ? '0px' : '2px',
              }}>
              <Box
                ref={iconRef}
                onClick={(e) => {
                  if (showWishlistIconHighlighted) return;
                  selectedWishlist?.id
                    ? handleAddInfluncerToList(row.id)
                    : handleStateWishlistDropdown(e, row.id, iconRef.current);
                }}
                sx={{
                  background:
                    showWishlistIconHighlighted ? 'linear-gradient(119deg,rgba(200, 80, 192, 1) 42%, rgba(65, 88, 208, 1) 100%)' : 'white',
                  borderRadius: showWishlistIconHighlighted ? '4px 0 0 4px' : '4px',
                  padding: '4px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  boxShadow: '0px 0px 4px 2px rgba(0, 0, 0, 0.04)',
                  height: '100%',
                  width: showWishlistIconHighlighted ? '30px' : '26px',
                  cursor: 'pointer', border: '0px solid red'
                }}
              >
                <img src={showWishlistIconHighlighted ? bookmarkWhite : plusWishlistIcon} alt="" style={{ height: '24px', width: '24px' }} />
              </Box>
              {showWishlistIconHighlighted && <Box
                onClick={() => handleDeleteInfluncersFromWishlist(row.id)}
                sx={{
                  background: 'white',
                  borderRadius: '0 4px 4px 0',
                  padding: '4px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  border: '2px solid #EAEAEA',
                  borderLeft: '0px',
                  height: '30px',
                  width: showWishlistIconHighlighted ? '30px' : '0px', display: showWishlistIconHighlighted ? "flex" : "none",
                  cursor: 'pointer',
                }}
              >
                <img src={deleteIcon} alt="" style={{ height: '20px', width: '20px' }} />
              </Box>}
            </Box>
          </Box>
        </TableCell>
        <TableCell component="td" scope="row">
          {getFixedValue(row?.followers) || "N/A"}
        </TableCell>
        <TableCell component="td" scope="row">
          {getFixedValue(row?.Engagement?.posts?.avg_likes) || "N/A"}
        </TableCell>
        <TableCell align="left">
          {filters?.platform === INSTAGRAM_TYPE_WITH_CAPS ? getFixedValue(row?.Engagement?.reels?.avg_views) : getFixedValue(row?.Engagement?.posts?.avg_views) || "N/A"}
        </TableCell>
        {filters?.platform === INSTAGRAM_TYPE_WITH_CAPS && <TableCell align="left">
          {getFixedValue(row?.Engagement?.posts?.engagement_rate) || "N/A"}
        </TableCell>}
        {filters?.platform === YOUTUBE_TYPE_WITH_CAPS && <TableCell align="left">
          {getFixedValue(row?.Engagement?.posts?.avg_comments)}
        </TableCell>}
        <TableCell align="left">
          {row?.creatorCategory || "N/A"}
        </TableCell>
        <TableCell align="left">
          <Tooltip
            componentsProps={TOOLTIP_STYLES}
            title={row?.location}
            arrow={true}
          >
            {trunCateString(row?.location, 20 || "N/A")}
          </Tooltip>
        </TableCell>
        <TableCell align="left" >
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
            {categories?.map((option, index) => (
              <>     {option?.title ?
                <Tooltip
                  title={option?.title}
                  arrow
                  componentsProps={TOOLTIP_STYLES}
                >
                  <Chip
                    key={option?.id}
                    label={option?.title?.length > 20 ? option?.title?.slice(0, 20) + '...' : option?.title}
                    avatar={<Avatar alt={option.title} src={`/influncersCategoryIcons/category_icon_${option.id}.svg`} sx={{ height: '20px !important', width: '20px !important' }} />}
                    sx={{
                      display: (index > 1 ? "none" : "flex  "),
                      flexDirection: 'row',
                      background: 'white !important', color: '#726C6C !important',
                      borderRadius: '62px', border: '1px solid #CCCBCB', fontSize: '12px', fontWeight: '500',
                      padding: "2px 8px", height: '32px', "&:hover": {
                        background: 'rgba(0, 0, 0, 0.04) !important',
                      }
                    }}
                  /></Tooltip> : "NA"}
              </>
            ))}
          </div>
        </TableCell>
      </>
    );
  }, [
    selectedInfluencers,
    selectedWishlist,
    checkIfIdIsAvailableInSelectedInfluncers,
    filters,
    handleAddInfluncerToList,
    handleDeleteInfluncersFromWishlist,
    handleDeleteInfluncersFromSelectedList,
    handleStateWishlistDropdown,
    dispatch
  ]);
  return (
    <Stack direction={"row"} sx={{position: 'relative', overflow: 'hidden', height: isScreenZoomed ? '91vh' : '93vh',boxShadow:'none'}}>
    <Box sx={{height: '100%',width: Boolean(wishlistId) ? isScreenZoomed ? '78%' : '82%' : '100%',  }}>
      <CustomizedSnackbars msgData={snackbar} setMsgData={setSnackbar} />
      <SearchBox />
      <Stack direction={"column"} gap={2} sx={{ position: 'relative', top: '0px' }}>
        <Box
          sx={{
            backgroundColor: '#fff',
            transition: 'all .5s ease-in-out',
            position: 'relative',
            border: 0,
            borderRadius: '0px',
          }}>
          <Paper sx={{ width: '100%', height: isScreenZoomed ? '72vh' :"77vh", border: '0px solid red', boxShadow:'none'}}>
            <TableVirtuoso
              data={list}
              style={{
                overflowY: 'scroll',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
              endReached={() => {
                if (!loading && hasMore) loadMore();
              }}
              context={{ loading, }}
              components={{
                Table: MemoizedTable,
                TableBody: TableBody,
                TableRow: MemoizedTableRow,
                EmptyPlaceholder: (props) => (<>{!showLoading && <TableRow
                  sx={{
                    "&:hover": {
                      backgroundColor: '#F0F7FF !important',
                      "& td": { backgroundColor: "inherit !important" },
                    },
                    height: '60px',
                  }}
                  {...props}
                  hover
                >
                  <TableCell colSpan={9} component="td" scope="row" sx={{ textAlign: 'center' }}>
                    <Typography fontSize={18} fontWeight={500} color={"#7A7A7A"}>
                      No Record Found
                    </Typography>
                  </TableCell>
                </TableRow>}
                </>
                ),
              }}
              fixedHeaderContent={() => headerContent}
              fixedFooterContent={() => footerContent}
              itemContent={renderItemContent}
            /> {loading && (
              <div style={{ textAlign: "center", padding: 16 }}>
                <CircularProgress size={24} />
              </div>
            )}
            <Menu
              anchorReference="anchorPosition"
              anchorPosition={
                menuPosition
                  ? { top: menuPosition.top, left: menuPosition.left }
                  : undefined
              }
              open={Boolean(menuPosition)}
              onClose={() => setMenuPosition(null)}
              sx={{
                '& .MuiMenu-list': {
                  paddingTop: 0,
                }
              }}
              PaperProps={{
                sx: {
                  mt: -0.7,
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  width: '200px',
                  maxWidth: '235px', marginTop: '5px'
                }
              }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
              <MenuItem
                sx={{
                  borderBottom: '1px solid #EEE', display: 'flex', justifyContent: 'space-between',
                  alignItems: 'center !important', padding: '10px 0px !important', "&:hover": { background: '#0077FF1A' }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
                }}
                onClick={() => {
                  setCreateWishlistModalOpen(true);
                }}
                defaultValue=""
              >
                <Stack direction="row" justifyContent="flex-start" gap={1} sx={{ px: 1 }} alignItems="center" ><img src={plusIcon} style={{ filter: 'invert(36%) sepia(98%) saturate(7476%) hue-rotate(201deg) brightness(101%) contrast(104%)', width: '20px', height: '20px' }} alt="plus icon" /> <Typography sx={{ fontSize: '16px', fontWeight: 500, color: 'var(--color-blue)' }}>Create new list</Typography></Stack>
              </MenuItem>
              <MenuItem
                disabled
                sx={{
                  borderBottom: '0px solid #EEE', display: 'flex', justifyContent: 'space-between',
                  alignItems: 'center !important', padding: '10px 0px !important', "&:hover": { background: '#0077FF1A' }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
                }}
                defaultValue=""
              >
                <Typography sx={{ flexGrow: 1, px: 1, fontSize: '16px', fontWeight: 500, color: '#2B2829' }}>You're lists</Typography>
              </MenuItem>
              {wishlistList?.slice(0,2)?.map((item) => (
                <MenuItem
                  sx={{
                    borderBottom: '0px solid #EEE', display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center !important', padding: '10px 0px !important', "&:hover": { background: '#0077FF1A' }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
                  }}
                  onClick={() => {
                    setSearchParams({ wishlistId: item.id });
                  }}
                  defaultValue=""
                >
                  <Tooltip  arrow componentsProps={TOOLTIP_STYLES} placement="top"  title={item?.name}>
                  <Typography sx={{ flexGrow: 1, px: 1, fontSize: '16px', fontWeight: 500, color: '#2B2829', textTransform: 'capitalize !important' }}>{trunCateString((item?.name || "")?.toLowerCase(), 15)}</Typography>
                  </Tooltip>
                </MenuItem>
              ))}
              <MenuItem
                sx={{
                  borderBottom: '0px solid #EEE', display: 'flex', justifyContent: 'space-between',
                  alignItems: 'center !important', padding: '10px 0px !important', "&:hover": { background: '#0077FF1A' }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
                }}
                onClick={() => {
                  setShowWishlistListingModal(true)
                }}
                defaultValue=""
              >
                <Typography sx={{ px: 1, fontSize: '16px', fontWeight: 500, color: '#7209B7' }}>View All list</Typography>
              </MenuItem>
            </Menu>
          </Paper>
          <CommonModel
            open={open}
            handleDialogClose={() => setOpen(false)}
            dialogTitle={"Remove Company"}
            dialogPara={`Are you sure you want to remove this company? `}
            nvYes={"Submit"}
            nvCancel={"Cancel"}
            yesHandle={() => {
              setOpen(false);
            }}
          />
          <CreateWishlistModal open={createWishlistModalOpen} setOpen={setCreateWishlistModalOpen} setActionDropdownState={setMenuPosition}/>
          {(selectedInfluencers?.length > 0) && <SelectedInfluncers setSearchParams={setSearchParams} selectedWishlist={selectedWishlist} dispatch={dispatch} handleAddInfluncerToList={handleAddInfluncerToList} setShowWishlistListingModal={setShowWishlistListingModal} setCreateWishlistModalOpen={setCreateWishlistModalOpen} setDeselectConfirmationModal={setDeselectConfirmationModal} />}
          <ConfirmationModal handleClick={handleDeselectAllInfluncer} open={deselectConfirmationModal} setOpen={setDeselectConfirmationModal} title={"Deselect Selected Influencers"} mainHeadingColor={'var(--red)'} subHeading={"Are you sure you want to deselect all the influencers you’ve chosen?"} logo={deselectGif} height='260px' />
          <WishlistListingModal setSearchParams={setSearchParams} open={showWishlistListingModal} setOpen={setShowWishlistListingModal} setCreateWishlistModalOpen={setCreateWishlistModalOpen} />
        </Box>
      </Stack>
    </Box>
  <Box
        sx={{
          width: Boolean(wishlistId) ? isScreenZoomed ? '22%' : '18%' : '0%',
          display: Boolean(wishlistId) ? 'block' : 'none',
          position:'relative',
          background: 'white',
          borderLeft: '1px solid rgba(170, 170, 170, 0.3)',
          borderTop: '1px solid rgba(170, 170, 170, 0.3)',
          height: '100%',
          overflow: 'hidden',
          scrollbarWidth: 0,
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        <WishlistSidebar />
      </Box>
    </Stack>
  );
}

export default memo(InfluencersListing)
